import { Avatar, Box, Tooltip } from "@mui/material";
import { styled } from "@mui/system";

export default function ServiceTypeTitle({ label, title, serviceTypeIcons, serviceTypeDescriptions }) {

    const TitleBox = styled(Box)(() => ({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    }));

    const TooltipBox = styled(Box)(() => ({
        display: 'flex',
        gap: '0.2rem'
    }));

    const TitleAvatar = styled(Avatar)(() => ({
        width: 18,
        height: 18,
        backgroundColor: 'white'
    }));

    const labelStyle = {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1,
        whiteSpace: 'nowrap'
    }

    return (
        <TitleBox sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            {title ? <span>{title}</span> : <span />}
            {label ? (<span style={labelStyle}>{label}</span>) : <span />}
            <TooltipBox sx={{ display: 'flex', gap: 0.5 }}>
                {serviceTypeIcons?.map((serviceTypeIcon, index) => (
                    <Tooltip key={index} title={serviceTypeDescriptions[index]}>
                        <TitleAvatar>
                            <Box component="img" src={serviceTypeIcon} sx={{ width: '0.875rem' }} />
                        </TitleAvatar>
                    </Tooltip>
                ))}
            </TooltipBox>
        </TitleBox>
    );
}